import {EventFormMode} from '@/types/event';
import {Box, Container, Dialog, IconButton, Tooltip} from '@mui/material';
import {useTheme} from '@mui/material';
import UndoIcon from '@mui/icons-material/Undo';
import {useTranslation} from 'react-i18next';

interface DialogFormProps {
  open: boolean;
  onCancel?: () => void;
  onSubmit?: (data: unknown) => void;
  onError?: (error: Error) => void;
  defaultGroup?: string;
  initialValues?: unknown;
  maxHeightAllowed?: string;
  groupOfEventChanged?: () => void;
  extraData?: unknown;
  updatingAdminCompany?: boolean;
  id?: string;
  eventId?: string;
  mode?: EventFormMode;
  isVerified?: boolean;
  withSubscription?: boolean;
  withGoBackIcon?: boolean;
  termsOfUseLink?: string;
  cancellationPolicyLink?: string;
  onDemand?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  FormComponent: React.ComponentType<any>;
}

const DialogForm: React.FC<DialogFormProps> = ({
  open,
  onCancel,
  onSubmit,
  onError,
  initialValues,
  FormComponent,
  defaultGroup,
  maxHeightAllowed = '800px',
  groupOfEventChanged,
  extraData,
  updatingAdminCompany,
  id,
  eventId,
  mode,
  isVerified,
  withSubscription,
  withGoBackIcon,
  termsOfUseLink,
  cancellationPolicyLink,
  onDemand
}) => {
  const theme = useTheme();
  const {t} = useTranslation();
  return (
    <Dialog open={open} onClose={onCancel} fullWidth={true} maxWidth="md">
      <Container
        sx={{
          backgroundColor: theme.palette.background.default,
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: 'none',
          pt: withGoBackIcon ? 1 : 4,
          maxHeight: {
            sm: maxHeightAllowed === 'no' ? 'false' : maxHeightAllowed,
            xs: 2000
          }
        }}
      >
        {withGoBackIcon && (
          <Box sx={{marginLeft: 1}}>
            <Tooltip title={t('screen_back')}>
              <IconButton
                onClick={() => {
                  if (onCancel) {
                    onCancel();
                  }
                }}
                color="primary"
              >
                <UndoIcon sx={{fontSize: {xs: 24, md: 28}}} />
              </IconButton>
            </Tooltip>
          </Box>
        )}

        <FormComponent
          onCancel={onCancel}
          onSubmit={onSubmit}
          onError={onError}
          initialValues={initialValues}
          defaultGroup={defaultGroup}
          groupOfEventChanged={groupOfEventChanged}
          extraData={extraData}
          updatingAdminCompany={updatingAdminCompany}
          companyId={id}
          eventId={eventId}
          mode={mode}
          isVerified={isVerified}
          withSubscription={withSubscription}
          termsOfUseLink={termsOfUseLink}
          cancellationPolicyLink={cancellationPolicyLink}
          onDemand={onDemand}
        />
      </Container>
    </Dialog>
  );
};

export default DialogForm;
